module.exports = __webpack_public_path__ + "media/images/background-team-800w-3e18306c.jpg";